var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[(_vm.consentRequired)?_c('div',{staticClass:"uk-overlay-default uk-position-cover uk-position-z-index uk-position-fixed"},[_c('div',{staticClass:"uk-position-center"},[_c('Consent')],1)]):_vm._e(),_c('Navbar'),_c('Notification'),_vm._t("default"),_c('div',{staticClass:"push"})],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }